import React, { PureComponent } from 'react';
import { CancelToken } from 'axios';
import { Helmet } from 'react-helmet';
import { WidgetMapaRadar } from '../../widgets/MapaRadar/WidgetMapaRadar';
import API from '../../utils/api';
import { translate } from '../../utils/translations';
import {
    buildLanguageConfig,
    consoleLogError,
    formatDateUi,
} from '../../utils/utils';
import { parse } from 'qs';
import PropTypes from 'prop-types';
import { WIDGETS_PADDING } from '../../utils/globals';

class MapaRadar extends PureComponent {
    state = {
        config: buildLanguageConfig({}),
        data: {},
        widgetDate: '',
    };

    static propTypes = {
        preview: PropTypes.bool,
        color: PropTypes.string,
        language: PropTypes.string,
    };

    render() {
        const { data, config, widgetDate } = this.state;
        return (
            <div className="MapaRadar main-wrapper" style={WIDGETS_PADDING}>
                <Helmet>
                    <title>{translate(config.language, 'radar_title')}</title>
                </Helmet>
                <WidgetMapaRadar
                    data={data}
                    config={config}
                    preview={this.props.preview}
                    widgetDate={widgetDate}
                />
            </div>
        );
    }

    componentDidMount() {
        this.feedWidget();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props !== prevProps) {
            this.feedWidget();
        }
    }

    componentWillUnmount() {
        this.cancelTokenSource.cancel(
            translate(this.state.config.language, 'cancelled_request')
        );
    }

    feedWidget = async () => {
        const search = this.props.location ? this.props.location.search : '';

        let config = {};

        // From Configurador form
        if (this.props.preview === true) {
            config = {
                color: this.props.color,
                language: this.props.language,
            };
        } else {
            // Or from Query String
            config = buildLanguageConfig(
                parse(search, {
                    ignoreQueryPrefix: true,
                })
            );
        }

        const widgetDate = formatDateUi(new Date());
        this.setState({ config, widgetDate });

        this.cancelTokenSource = CancelToken.source();
        try {
            let data = await API.getRadar(this.cancelTokenSource.token);
            this.setState({ data: data.data });
        } catch (e) {
            consoleLogError(e, this.state.config.language);
        }
    };
}

export default MapaRadar;



// WEBPACK FOOTER //
// ./src/containers/MapaRadar/MapaRadar.js